import type { IntakeFormQuestion } from "@/modules/agent/requests/vendor-intake-form-response";
import type { IntakeFormQuestionV2 } from "@/modules/third-party-risk/types/intake-form-v2";

export function mapV2ToIntakeQuestion(
  q: IntakeFormQuestionV2,
): IntakeFormQuestion {
  return {
    id: q.id,
    question_number: q.question_number,
    question: q.question,
    field_name: q.field_name,
    question_type: q.question_type,
    required: q.required,
    is_dropdown: q.is_dropdown,
    hidden_from_user: false,
    response_choices: (q.response_choices ?? []).map((c) => c.label),
    max_number_of_files: q.max_number_of_files,
    source_urls: q.source_urls,
    response: q.response,
    parent_question_field_name: q.parent_question_field_name ?? null,
    parent_trigger_values: q.parent_trigger_values ?? null,
  };
}

export function mapV2QuestionsToIntakeQuestions(
  questions: IntakeFormQuestionV2[],
): IntakeFormQuestion[] {
  return questions
    .map(mapV2ToIntakeQuestion)
    .sort((a, b) => a.question_number - b.question_number);
}
